"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindMethod = bindMethod;
exports.bindMethods = bindMethods;
exports.has = exports.get = exports.default = void 0;
exports.merge = merge;
exports.values = exports.traverse = exports.stringify = exports.set = exports.pick = exports.omitBy = exports.omit = exports.mergeDeep = void 0;
var get = require('lodash.get');
exports.get = get;
var has = require('lodash.has');
exports.has = has;
var omit = require('lodash.omit');
exports.omit = omit;
var omitBy = require('lodash.omitby');
exports.omitBy = omitBy;
var pick = require('lodash.pick');
exports.pick = pick;
var set = require('lodash.set');
exports.set = set;
var stringify = require('json-stringify-safe');
exports.stringify = stringify;
var traverse = require('traverse');
exports.traverse = traverse;
var values = require('lodash.values');
exports.values = values;

var _merge = require('lodash.merge');
function merge() {
  var result = {};
  _merge(result, ...arguments);
  return result;
}
var mergeDeep = merge;
exports.mergeDeep = mergeDeep;
function bindMethod(object, methodName) {
  object[methodName] = object[methodName].bind(object);
}
function bindMethods(object, methodNames) {
  methodNames.forEach(methodName => {
    bindMethod(object, methodName);
  });
}
var _default = {
  bindMethod,
  bindMethods,
  get,
  has,
  merge,
  mergeDeep,
  omit,
  omitBy,
  pick,
  set,
  stringify,
  traverse,
  values
};
exports.default = _default;